jQuery(document).ready((function($){
    var options = {
        target: '.img-fit',
        fallback: 'img-fit--fallback'
    }

    if(objectFitSupport() === false){

        jQuery(options.target).each((function() {

            var $container = jQuery(this),
                imgUrl = $container.find('img').prop('src');

            if (imgUrl) {
                $container
                    .css('background-image', 'url(' + imgUrl + ')')
                    .addClass(options.fallback);
            }
        }));
    }

    function objectFitSupport() {
        if('objectFit' in document.documentElement.style === true) {
            return true
        }

        return false;
    }
}));
